import { ResourceAppModule } from "./app";
import { RouteConfig } from "vue-router";

export const resourceModuleRouteConfig = (
  module: ResourceAppModule,
  children: RouteConfig[] = [],
) =>
  ({
    path: module.route,
    meta: { module },
    component: {
      render: (h) => h("router-view"),
    },
    children: [
      {
        path: "/",
        component: () => import("@/components/resource/ResourceModulePage.vue"),
        props: { module },
      },
      {
        path: "new",
        component: () => import("@/components/resource/NewItemCard.vue"),
        meta: { action: "Nowy rekord" },

        props: { module },
      },
      {
        path: ":id",
        component: () => import("@/components/resource/ResourceItemView.vue"),
        meta: { action: " " },

        props: { module },
      },
      ...children,
    ],
  } as RouteConfig);

export const revisionModuleRouteConfig = (
  module: ResourceAppModule,
  children: RouteConfig[] = [],
) =>
  ({
    path: module.route,
    meta: { module },
    component: {
      render: (h) => h("router-view"),
    },
    children: [
      {
        path: "/",
        component: () => import("@/components/resource/RevisionModulePage.vue"),
        props: { module },
      },
      {
        path: "new",
        component: () => import("@/components/resource/NewItemCard.vue"),
        meta: { action: "Nowy rekord" },
        props: { module },
      },
      {
        path: "drafts",
        component: () => import("@/components/resource/DraftsView.vue"),
        meta: { action: "Werjse robocze" },
        props: { module },
      },
      {
        path: ":id",
        component: () => import("@/components/resource/RevisionItemView.vue"),
        meta: { action: " " },
        props: { module },
      },

      ...children,
    ],
  } as RouteConfig);
